import { AxiosPromise } from "axios";

import api from "../config/api-supplier-config";

interface ParametersPurchaseOrder {
  scheduled: boolean;
  onTime: boolean;
  lated: boolean;
}

export function getSuppliers(): AxiosPromise {
  return api.get("v1/suppliers", {});
}

export function getStores(): AxiosPromise {
  return api.get("v1/stores", {});
}

export function getPurchaseOrders(
  params: ParametersPurchaseOrder,
  storeId: any,
  supplierId: any
): AxiosPromise {
  return api.get(
    `v1/purchase-orders/stores/${storeId}/suppliers/${supplierId}?scheduled=${params?.scheduled}&onTime=${params?.onTime}&lated=${params?.lated}`,
    {}
  );
}

export function postPurchaseOrders(params: any, storeId: any): AxiosPromise {
  return api.post(`v1/purchase-orders/stores/${storeId}/skus`, params, {});
}

export default {
  getSuppliers,
  getPurchaseOrders,
  postPurchaseOrders,
  getStores,
};
